import {
  LayoutListDefinition,
  FolderGridDefinition,
  LAYOUT_LIST,
  TEXT,
  FOLDER_BOX,
  ADD_FOLDER,
  STATIC_CARD,
  FOLDER_GRID
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { Quiz13Steps } from './Quiz13Steps';
import { useEditorStore } from '~/shell/Store';

export const Quiz13: Translator = sequence => {
  // Detect if we are in editor mode using the store
  const { editorMode } = useEditorStore.getState();

  // If NOT in editor (editorMode = false), use Quiz13Steps for the game
  if (!editorMode) {
    return Quiz13Steps(sequence);
  }

  return translate(sequence, item => {
    if (item.__typename === 'Question') {
      const listItem: LayoutListDefinition = {
        id: `${item.id}_text-list`,
        type: LAYOUT_LIST,
        values: {
          padded: true,
          align: 'center',
          height: 'auto'
        },
        items: []
      };

      if (item.subtitle) {
        listItem.items.push({
          id: `${item.id}_subtitle`,
          type: TEXT,
          values: {
            value: item.subtitle,
            variant: 'sub_heading'
          },
          items: []
        });
      }

      if (item.title) {
        listItem.items.push({
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            value: item.title,
            variant: 'heading1'
          },
          items: []
        });
      }

      if (item.body) {
        listItem.items.push({
          id: `${item.id}_body`,
          type: TEXT,
          values: {
            value: item.body
          },
          items: []
        });
      }

      listItem.items.push({
        id: 'static-placeholder-card',
        type: STATIC_CARD,
        values: {
          text: 'Cards will be displayed here',
          width: '250px',
          height: '170px',
          padding: '40px',
          borderRadius: '15px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          fontWeight: 'bolder',
          fontSize: '18px'
        },
        items: []
      });

      const foldersContainer: FolderGridDefinition = {
        id: `${item.id}_folders-container`,
        type: FOLDER_GRID,
        values: {},
        items: []
      };

      if (item.items && item.items.length > 0) {
        // Sort folders by position to ensure correct order
        const sortedItems = [...item.items].sort(
          (a: { position?: number | null }, b: { position?: number | null }) =>
            (a.position || 0) - (b.position || 0)
        );

        sortedItems.forEach(({ id, feedback }) => {
          foldersContainer.items.push({
            id: `${id}_feedback`,
            type: FOLDER_BOX,
            values: {
              value: feedback || '',
              editable: true
            },
            items: []
          });
        });
      }

      foldersContainer.items.push({
        id: `${item.id}_add-folder`,
        type: ADD_FOLDER,
        values: {
          label: 'Add Folder'
        },
        items: []
      });

      listItem.items.push(foldersContainer);

      return listItem;
    }
    return null;
  });
};
